// 新會員有效期為入會隔年 12/31 時，等到入會隔年 9/1 才開始提醒。
export function getAnnualPointsReminder(user, now = new Date()) {
  const state = { showExit: false, showFirst: false, showlastMonth: false }
  if (user.exited_at) return { ...state, showExit: true }

  const created = new Date(user.created_at || NaN)
  const expiry = new Date(user.expiry_day || NaN)
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const joinedYear = created.getFullYear()
  const hasInitialExpiry = expiry.getFullYear() === joinedYear + 1 &&
    expiry.getMonth() === 11 && expiry.getDate() === 31
  const firstReminder = new Date(joinedYear + 1, 8, 1)
  if (created.setHours(0, 0, 0, 0) <= now.getTime() && hasInitialExpiry && now < firstReminder) {
    return state
  }

  if (month >= 9) return { ...state, showlastMonth: true }
  if (joinedYear === year) return state
  return { ...state, showFirst: true }
}
